import { template2Styling } from "@made-people/blueprint-header/blueprint";
import { searchInputBlueprint } from "@made-people/blueprint-search/blueprint";

template2Styling.main.override({
  slots: {
    wrapper:
      "w-full bg-background-page border-b border-border-light sticky top-0 z-10",
    nav: "flex gap-4 p-0 px-3 py-2",
    left: "flex justify-start items-center pl-2 gap-4 flex-1",
    right: "flex justify-end items-center gap-1 flex-1",
    center: "w-full flex-1",
    siteSettingsTrigger: "text-label-sm font-primary whitespace-nowrap",
  },
});

template2Styling.searchTrigger.override({
  slots: {
    wrapper: "flex gap-0 items-center",
    icon: "w-5 h-5 flex justify-center items-center [&>svg]:w-[17px]",
    label: "text-body-sm",
  },
});

template2Styling.cartTrigger.override({
  slots: {
    wrapper: "flex gap-2 items-center relative",
    counter:
      "w-4 h-4 flex justify-center items-center rounded-full text-[10px] text-white bg-black font-medium absolute top-1 right-1",
    icon: "w-9 h-10 flex justify-center items-center [&>svg]:w-[16px] [&>svg]:h-[18px]",
    label: "",
  },
});

template2Styling.accountTrigger.override({
  slots: {
    wrapper: "flex gap-2 items-center",
    icon: "w-9 h-10 flex justify-center items-center [&>svg]:w-[16px] [&>svg]:h-[18px]",
    label: "",
    loggedInInitials:
      "size-6 text-[10px] text-[--foreground] border border-[--foreground] rounded-full flex items-center justify-center",
  },
});

template2Styling.logo.override({
  slots: {
    wrapper: "flex justify-center items-center",
    link: "h-10 flex justify-end items-center",
  },
});

searchInputBlueprint.override({
  slots: {
    wrapper:
      "rounded-full relative focus-within:shadow-shadow-sharp hover:shadow-shadow-sharp transition hover:-translate-x-0.5 hover:-translate-y-0.5 focus-within:-translate-x-0.5 focus-within:-translate-y-0.5 w-full",
    inputField:
      "h-10 w-full rounded-full text-base lg:text-sm pl-11 font-medium border-transparent focus:outline-none transition-colors [&::-webkit-search-cancel-button]:hidden",
    iconSearch: "absolute size-5 aspect-square left-3 top-1/2 -translate-y-1/2",
    iconLoading:
      "absolute size-6 aspect-square right-2 top-1/2 -translate-y-1/2 lg:hidden",
    clearText:
      "text-body-xs text-gray-500 absolute top-1/2 -translate-y-1/2 right-4 lg:right-6",
  },
  variants: {
    color: {
      white: {
        inputField: "",
      },
      grey: {
        inputField: "",
      },
    },
  },
});
